import {Button, Input} from "antd";
import React, {useCallback, useEffect, useState} from "react";
import "./emailSignIn.css"
import {useHistory} from "react-router";
import {Http} from "../../../../helpers/axois";
import {useToast} from "../../../../helpers/commonFunction";
import {decode} from 'jsonwebtoken'
import {useDispatch} from "react-redux";
import {saveDetails, setUser} from "../../../../stateManager/store/user/actions";
import {logger} from "../../../../constant/winston";
import { redirectOnLogin } from "../../../../helpers/util";


interface Iprops {
    // setLoginState: (state:string) => void;
}

const EmailSignIn = (props: Iprops) => {
    const history = useHistory()
    const {ErrorToast, SuccessToast} = useToast()
    const dispatch = useDispatch();
    const [ signInCredentials, setSignInCredentials ] = useState({
        userName: "",
        password: "",
    })
    const [ emptyError, setEmptyError ] = useState('');

    const handleSignIn = useCallback(() => {
        try {
            if (signInCredentials.userName !== "" && signInCredentials.password !== "") {

                Http.post("signIn", signInCredentials).subscribe(
                    (res: any) => {
                        let {firstName, email, lastName, userName} = res
                        SuccessToast('Login successful')
                        const decoded = decode(res.token);
                        dispatch(setUser({user: decoded}));
                        localStorage.setItem("studioToken", res.token);
                        localStorage.setItem("studioRefreshToken", res.refreshToken);

                        if(redirectOnLogin(res.token)) {
                            return
                        }

                        // document.cookie = res;
                        history.push("/home");
                        dispatch(saveDetails({
                            firstName, email,
                            lastName: lastName,
                            userName: userName
                        }));
                        // window.location.reload();
                    },
                    err => {
                        ErrorToast(err.message ? err.message : err)
                    }
                );
            } else {
                if (signInCredentials.userName === "" && signInCredentials.password === "") {
                    setEmptyError('both');
                    ErrorToast('Fill user name and password')
                } else {
                    ErrorToast((signInCredentials.userName === "") ? "Fill the user name field" : "Fill the password field")
                    setEmptyError(signInCredentials.userName === "" ? 'userName' : 'password')
                }
            }
        } catch (e) {
            logger.error("error", e);
        }
    }, [ signInCredentials, history, ErrorToast, SuccessToast, dispatch ]);

    return (
        <div className="signIn-container">
            <div className="heading">Sign In</div>
            <div className="subtext">Log in with your provided username.</div>
            <Input
                onChange={(e: any) => {
                    setEmptyError('');
                    setSignInCredentials({...signInCredentials, userName: e.target?.value})
                }}
                style={{borderColor: (emptyError === 'userName' || emptyError === 'both') ? "rgba(235, 0, 27, 1)" : "#D9D9D9"}}
                className="custom-input"
                data-test-id="username"
                placeholder="Username or email address*"
            ></Input>
            {(emptyError === "both" || emptyError === "userName") && <div style={{width:"370px", marginTop:"5px", fontSize:"13px", fontWeight:400, color:"#EB001B"}} data-test-id="username_errmsg">Enter valid username</div>}
            <Input.Password
                onChange={(e: any) => {
                    setSignInCredentials({...signInCredentials, password: e.target?.value});
                    setEmptyError('')
                }} className="custom-input-password"
                data-test-id="password"
                style={{marginTop: "24px", border: (emptyError === 'password' || emptyError === 'both') ? "1px solid rgba(235, 0, 27, 1)" : "0.1px solid #D9D9D9"}}
                placeholder="Password*"
            ></Input.Password>
            {(emptyError === "both" || emptyError === 'password') && <div style={{width:"370px", marginTop:"5px", fontSize:"13px", fontWeight:400, color:"#EB001B"}} data-test-id="password_errmsg">Enter valid password</div>}
            <Button onClick={handleSignIn} className="signIn-button" data-test-id="login_btn">Sign In</Button>
            <div className="terms-text">
                <p style={{color: "#6C6C6C", fontWeight: 400, fontSize: "13px"}} >By continuing, you agree to our
                    <a href="https://autonom8.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="terms-link"> Terms of Service & Privacy Policy</a>
                </p>
            </div>
            <div style={{borderTop: "0.75px dashed #8E99BA", height: "2px", width: "370px"}} ></div>
            <div style={{ display:"flex", alignItems:"center", margin: "15px 0px 12px 0px", height:"25px"}}>
                <p style={{marginRight:"3px",fontSize: "14px", fontWeight: 400, color: "#6C6C6C", marginBottom:"0px"}}>Forgot Password?</p>
                <span 
                onClick={() => history.push("/forgotPassword")}
                    style={{ fontSize: "16px", fontWeight: 600, cursor: "pointer", color: "#052F35"}}
                >Reset Now</span>
            </div>

            <div style={{
                display:"flex",
                alignItems:"center",
                height:"25px"
            }}
            >
                <p style={{marginRight:"3px",fontSize: "14px", fontWeight: 400, color: "#6C6C6C", marginBottom:"0px"}}>Don’t have an account?</p>
                <span onClick={() => history.push("/signup")}
                    style={{ fontSize: "16px", fontWeight: 600, cursor: "pointer", color: "#052F35"}}
                >
                    Sign Up
                </span>
            </div>
        </div>
    )
}

export default EmailSignIn;